import { Button } from '@creanizer/ui'
import { Save } from 'lucide-react'
import type { ItemResult } from '@creanizer/types'
import { ItemResult as ItemResultDisplay } from './ItemResult'

interface ItemGeneratorBatchProps {
  results: ItemResult[]
  onSave: (result: ItemResult, index: number) => void
  onSaveAll: () => void
  isSaved: (result: ItemResult) => boolean
  onEdit?: (updatedResult: Partial<ItemResult>, index: number) => void
}

export function ItemGeneratorBatch({ 
  results, 
  onSave, 
  onSaveAll, 
  isSaved,
  onEdit 
}: ItemGeneratorBatchProps) {
  // 防御的チェック - 無効なデータをフィルタリング
  const validResults = results?.filter(r => r && r.basicInfo && r.basicInfo.name) || []
  
  if (validResults.length === 0) {
    return (
      <div className="text-center text-muted-foreground p-4">
        有効なアイテムデータがありません
      </div>
    )
  }

  const allSaved = validResults.every(r => isSaved(r))

  return (
    <div className="space-y-4">
      {validResults.length > 1 && (
        <div className="flex justify-end">
          <Button
            onClick={onSaveAll}
            disabled={allSaved}
          >
            <Save className="h-4 w-4 mr-2" />
            すべて保存 ({validResults.length}個)
          </Button>
        </div>
      )}
      
      {validResults.map((result, index) => (
        <div key={index} className="card p-6">
          <ItemResultDisplay
            result={result}
            onSave={() => onSave(result, index)}
            isSaved={isSaved(result)}
            isBatch={validResults.length > 1}
            batchIndex={index}
            onEdit={onEdit ? (updatedResult) => onEdit(updatedResult, index) : undefined}
          />
        </div>
      ))}
    </div>
  )
}